import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { QuestionnaireEditorComponent } from '../questionnaire-editor.component';

@Injectable()
export class QuestionnaireEditorGuard implements CanDeactivate<QuestionnaireEditorComponent> {
  
  canDeactivate(component: QuestionnaireEditorComponent): Promise<boolean> | boolean {
    return component.canDeactivate();
  }
}
